
export const storeAnswer = async (resource,data) => {
    let answer;
    await resource
      .post(`api/${localStorage.getItem('perfil')}/answer`,data)
      .then(
        (response) => {
          console.log(response);
          answer = response.body.answer;
        },
        (response) => {
          console.log(response);
        }
      );
    return answer;
  }

  
export const getAnswer = async (resource,questionary_id,user_id) => {
  let answer;
  await resource
    .get(`api/${localStorage.getItem('perfil')}/answer/find_by_user_id/${user_id}/${questionary_id}`)
    .then(
      (response) => {
        console.log(response);
        answer = response.body.answer;
      },
      (response) => {
        console.log(response);
      }
    );
  return answer;
}

export const getAnswersByQuestionry = async (resource,id) => {
  let answer;
  await resource
    .get(`api/${localStorage.getItem('perfil')}/answer/find_by_questionary_id/${id}`)
    .then(
      (response) => {
        console.log(response);
        answer = response.body.answer;
      },
      (response) => {
        console.log(response);
      }
    );
  return answer;
}

  
